const styles = (theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 60px)',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingTop: 60,
    /**
     * Prevents zoom on double tap.
     * @see [OSP-8706]
     */
    touchAction: 'manipulation',
  },
  keysContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 60px)',
    gap: '30px 20px',
  },
  roundBtn: {
    borderRadius: '50%',
    minWidth: 60,
    height: 60,
    color: 'inherit',
  },
  keyBtn: {
    backgroundColor: theme.color.grey_mist,
    '&:hover': {
      backgroundColor: theme.color.grey_mist,
    },
  },
  btnLabel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    height: '100%',
  },
  btnLabelCentered: {
    justifyContent: 'center',
  },
  keyTitle: {
    fontSize: 32,
    lineHeight: '30px',
  },
  keyTitleScaled: {
    fontSize: 40,
  },
  keyLabel: {
    fontSize: 12,
    lineHeight: '10px',
    letterSpacing: '0.24px',
  },
  textField: {
    color: 'inherit',
  },
  input: {
    fontSize: 32,
    textAlign: 'center',
    cursor: 'context-menu',
  },
});

export default styles;
